if (!customElements.get('search-suggestions')) {
  const SearchSuggestions = class extends HTMLElement {
    connectedCallback() {
      this.searchTimeoutID = -1;
      this.searchInput = this.closest('form').querySelector('input[name="q"]');
      this.searchInput.addEventListener('keyup', this.handleInputChange.bind(this));
      this.searchInput.addEventListener('change', this.handleInputChange.bind(this));
    }

    handleInputChange() {
      const valueToSearch = this.searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        clearTimeout(this.searchTimeoutID);

        this.searchTimeoutID = setTimeout(() => {
          this.fetchSuggestions(valueToSearch);
        }, 500);
      } else if (!valueToSearch.length) {
        clearTimeout(this.searchTimeoutID);

        if (this.searchSuggestionsAbortController) {
          this.searchSuggestionsAbortController.abort('Existing request not needed');
          this.searchSuggestionsAbortController = null;
        }

        this.innerHTML = '';
      }

      this.oldSearchValue = valueToSearch;
    }

    fetchSuggestions(terms) {
      if (this.searchSuggestionsAbortController) {
        this.searchSuggestionsAbortController.abort('Existing request not needed');
      }
      this.searchSuggestionsAbortController = new AbortController();

      // PARCHE NEW ERA - mantener al actualizar el tema.
      // Hay que pedir los tipos. El valor por defecto de la API de busqueda
      // predictiva de Shopify es `product`, asi que sin esto
      // `predictive_search.resources.queries` llega vacio y la seccion
      // `search-suggestions` se pinta entera vacia: el bloque existia, cargaba
      // su JS y no ensenaba nada.
      //
      // Va en SU PROPIA peticion y no junto a la de productos porque
      // `resources[limit]` se reparte entre los tipos: pedirlo todo junto
      // dejaria el buscador con 2 productos en vez de los 4 que se piden.
      const suggestionsParams = new URLSearchParams({
        q: terms,
        section_id: 'search-suggestions',
        'resources[type]': 'query,collection',
        'resources[limit]': 6
      });

      fetch(`${theme.routes.predictiveSearch}?${suggestionsParams}`, {
        signal: this.searchSuggestionsAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.search-suggestions-wrapper');

          this.innerHTML = '';
          this.insertAdjacentElement('beforeend', results.firstElementChild);
        })
        .catch((error) => {
          console.warn(error); // eslint-disable-line no-console
          if (error.code === 20) {
            return; // aborted
          }
          throw error;
        });
    }
  };

  window.customElements.define('search-suggestions', SearchSuggestions);
}
